module.exports = __webpack_public_path__ + "js/modern/ripples.worklet.499ad109.js";